import { get } from 'lodash'
import { formatCartItemModifiers, displayCartItemPrice } from '../utils/formatters'

const CartItemViewModel = (cartItem) => {
  const modifiers = get(cartItem, 'modifiers', [])
  const notes = get(cartItem, 'notes', null)
  const modifiersString = formatCartItemModifiers(modifiers, notes)

  return {
    orderMaxAmount: get(cartItem, 'orderMaxAmount', null),
    orderMinCount: get(cartItem, 'orderMinCount', null),
    isAlcohol: get(cartItem, 'isAlcohol', false),
    id: get(cartItem, 'id', ''),
    name: get(cartItem, 'name', ''),
    price: displayCartItemPrice(cartItem, modifiers),
    color: get(cartItem, 'color'),
    priceInCents: get(cartItem, 'defaultPriceInCents', 0),
    quantity: get(cartItem, 'quantity', 1),
    fractionalQuantity: cartItem?.quantity ?? 1, 
    modifiers,
    notes,
    modifiersString,
  }
}

export default CartItemViewModel
